import styled from 'styled-components';

export const IvrSettingsPanel = styled.aside`
  width: 320px; flex: 0 0 320px; min-height: 0; display: flex; flex-direction: column;
  background: ${({ theme }) => theme.color.primary_100}; border-left: 1px solid ${({ theme }) => theme.color.primary_300}; color: ${({ theme }) => theme.color.text_color_100};
  header, footer { display: flex; align-items: center; gap: 8px; padding: 16px; }
  header { border-bottom: 1px solid ${({ theme }) => theme.color.primary_300}; }
  header h2 { margin: 0; flex: 1; font-size: 14px; }
  footer { border-top: 1px solid ${({ theme }) => theme.color.primary_300}; justify-content: flex-end; }
`;

export const IvrSettingsFields = styled.div`
  flex: 1; overflow-y: auto; padding: 16px; display: flex; flex-direction: column; gap: 20px;
  label { display: flex; flex-direction: column; gap: 8px; }
  input, select, textarea { min-width: 0; width: 100%; }
  small { font-size: 12px; color: ${({ theme }) => theme.color.text_color_300}; }
`;
